'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import { useMediaQuery } from 'modules/mui/hooks';
import { Accordion } from '../Accordion';
import { IAccordion } from '../types';
import styles from './AccordionWithImage.module.css';

export const AccordionWithImage: FC<IAccordion> = ({
  children,
  defaultExpanded = false,
  src,
  alt,
  id,
  classes,
  ...accordionProps
}) => {
  const { isMobile } = useMediaQuery();

  return (
    <div id={id} className={styles.root}>
      <Accordion
        defaultExpanded={defaultExpanded}
        classes={{
          bareRoot: styles.bareRoot,
          details: clsx(
            !src && isMobile && styles.mobileDetails,
            styles.details,
            classes?.details,
          ),
          summaryRoot: styles.summaryRoot,
          content: styles.content,
          ...classes,
        }}
        headingColor="purple"
        {...accordionProps}
      >
        <div>{children}</div>
        {src && (
          <div className={styles.imageContainer}>
            <Image src={src} className={styles.image} alt={alt} />
          </div>
        )}
      </Accordion>
    </div>
  );
};
